import { uiApi } from "./ui-api";

export function track(system: string, event: string, data?: any) {
  uiApi.postRaw("/z/track", { system, event, data }).catch(console.error);
}
